<template>
  <b-card no-body>
    <b-card-header>
      Download keuringen
    </b-card-header>
    <b-card-body v-if="options">
      <b-row>
        <b-col>
          <!--- input group checkbox --->

          <b-form-checkbox-group
            v-model="filter.certificaat"
            :options="keuringstatus"
            size="sm"
          />

          <b-form-group label="Beheer">
            <b-form-radio-group
              id="btn-radios-2"
              v-model="filter.status"
              :options="status"
              buttons
              button-variant="outline-primary"
              size="sm"
              name="radio-btn-outline"
            /> 
          </b-form-group>
          <!--- input group checkbox: -->
        </b-col>
        <b-col>
          <b-checkbox 
            v-model="filter.download" 
            size="sm"
          >
            Download
          </b-checkbox>
          <b-input-group 
            v-for="f in ['installateur','keuringsinstantie','relatie']" 
            :key="f" 
            class="mb-3"
          >
            <b-input-group-prepend is-text>
              {{ f }}
            </b-input-group-prepend>
            <b-select 
              v-model="filter[f]" 
              :options="options[f + 's']" 
            >
              <template #first>
                <option value="">
                  Alle {{ f }}s
                </option>
              </template>
            </b-select>
          </b-input-group>
        </b-col>
        <b-col>
          <!--- toon overzicht kollomen --->
          <b-form-group label="Kolommen">
            <b-form-checkbox-group
              v-model="filter.cols"
              :options="cols"
              size="sm"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card-body>
    <b-card-footer>
      <b-button 
        variant="success"
        class="float-right"
        size="lg"
        @click="download_excel"
      >
        <i class="fa fa-table" /> 
        Download Excel
      </b-button>
    </b-card-footer>
  </b-card>
</template>
<script>
import { saveAs } from "file-saver";
import { serviceMixin } from '@/mixins/serviceMixin';
import { keuringMixin } from '../../mixins/keuringMixin';
export default {
    name: 'DownloadKeuringen',
    components: {
    },
    mixins: [
      serviceMixin,
      keuringMixin
    ],
    props: {
    },
    data() {
        return  {

          cols: [
                'unitnummer',
                'adres',
                'wijk_plaats',
                'onderhoudsnummer',
                'onderhoudsfirma',
                'relatie',
                'keuringsinstantie',
                'keuringsuitslag'
            ],
            status: [
              { text: "Uit contract", value: 0, variant: "warning", count: 0},
              { text: "In beheer", value: 1, variant: "success", count: 0},
              { text: "Subbeheer", value: 2, variant: "warning", count: 0},
              { text: "Losse inspectie", value: 3, variant: "info", count: 0}
            ],
            filter: {
                installateur: '',
                download: false,
                keuringsinstantie: '',
                relatie: '',
                certificaat: [ -3, -2, -1, 0, 1 ],
                status:1,
                cols: [
                    'unitnummer',
                    'adres',
                    'wijk_plaats',
                    'onderhoudsnummer',
                    'onderhoudsfirma',
                    'relatie',
                    'keuringsinstantie',
                    'keuringsuitslag'
                ]
            },
            options: null
        }
    },
    computed: {},
    watch: {},
    mounted () {
        // get /keuringen/export
        this.get_keuringen_export();
    },
    methods: {
        download_excel() {
          console.log('download excel');
          var vm = this;
          this.$http.post('/export/keuringen', this.filter, { responseType: "arraybuffer" })
            .then(response => {
              if (vm.filter.download) {
                var blob = new Blob([response.data], {
                  type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(blob, 'keuringen.xlsx');
              } else {
                console.log(response.data);
                alert(response.data.keuringen);
                
              }
            });
        },
        get_keuringen_export() {
            this.get('/export/keuringen')
            .then(response => {
               console.log(response.data);
                this.options = response.data.options;
            })
            .catch(error => {
                console.log(error);
            });
        },
    },
          
}

</script>